import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=1fa05564"
import script from "./CourseItem.vue?vue&type=script&lang=ts"
export * from "./CourseItem.vue?vue&type=script&lang=ts"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=1fa05564&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports